import React, { Component } from 'react'
import { Button, Checkbox, Col, DatePicker, Form, Input, message, Modal, Row, Select } from 'antd'
import moment from 'moment'
import { omit } from 'lodash'
import omitEmpty from 'omit-empty'
import Events from '../../../api/Events'

const FormItem = Form.Item
const Option = Select.Option
const { TextArea } = Input
const { RangePicker } = DatePicker

class AddEvent extends Component {
  api = new Events()
  state = { loading: false }
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        let event = Object.assign({}, values)
        event.start = {
          date: values.dateRange[0].format('YYYY-MM-DD'),
          dateTime: values.dateRange[0].format(),
          milliseconds: values.dateRange[0].unix(),
        }
        event.end = {
          date: values.dateRange[1].format('YYYY-MM-DD'),
          dateTime: values.dateRange[1].format(),
          milliseconds: values.dateRange[1].unix(),
        }
        event.calendar = { _id: values.calendar }
        event = omit(event, ['dateRange'])
        event = omitEmpty(event)
        try {
          this.setState({ loading: true })
          await this.api.create(event)
          this.props.form.resetFields()
          message.success('Created!')
          this.props.handleCancel(true)
        } catch (error) {
          this.setState({ loading: false })
          message.error(error.errorMessage)
        }
      }
    })
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }

    const { getFieldDecorator } = this.props.form
    const { visible, handleOk, handleCancel, info, calendars } = this.props
    return (
      <Modal
        title="Create an Event"
        destroyOnClose={true}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={763}
        footer={
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button loading={this.state.loading} type="primary" onClick={this.handleSubmit}>
                Create
              </Button>
              <Button onClick={handleCancel} style={{ marginLeft: 8 }}>
                Close
              </Button>
            </Col>
          </Row>
        }>
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <FormItem hasFeedback {...formItemLayout} label="Event">
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: "Event can't be empty ",
                },
              ],
            })(<Input placeholder="New Event" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="All-Day">
            {getFieldDecorator('allDay')(<Checkbox />)}
          </FormItem>

          <FormItem {...formItemLayout} label="Description">
            {getFieldDecorator('description')(<TextArea placeholder="Event Description" />)}
          </FormItem>
          <FormItem hasFeedback {...formItemLayout} label="Date">
            {getFieldDecorator('dateRange', {
              initialValue: [moment(info.start), moment(info.end)],
              rules: [
                {
                  required: true,
                  message: 'Date range need to be selected ',
                },
              ],
            })(<RangePicker style={{ width: '100%' }} showTime={{ format: 'HH:mm' }} format="ddd YYYY-MM-DD HH:mm" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Calender">
            {getFieldDecorator('calendar', {
              rules: [
                {
                  required: true,
                  message: "calender can't be empty ",
                },
              ],
            })(
              <Select placeholder="Select a Calender .. ">
                {calendars.map((c) => (
                  <Option value={c._id}>{c.name}</Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

const WrappedAddEventForm = Form.create()(AddEvent)

export default WrappedAddEventForm
